import {
	Button,
	Icon,
	Loading,
	Form,
	Field,
	CellGroup,
	Col,
	Row,
	Lazyload,
	Tag,
	Progress,
	Badge,
	Swipe,
	SwipeItem,
	Toast,
	Dialog,
	Image as VanImage,
} from "vant";

export default (vue3App) => {
	vue3App.use(Button);
	vue3App.use(Icon);
	vue3App.use(Loading);
	vue3App.use(Col);
	vue3App.use(Row);
	vue3App.use(Lazyload, {
		lazyComponent: true,
	});
	vue3App.use(Tag);
	vue3App.use(VanImage);
	vue3App.use(Progress);
	vue3App.use(Badge);
	vue3App.use(Swipe);
	vue3App.use(SwipeItem);
	vue3App.use(Toast);
	vue3App.use(Dialog);
	vue3App.use(Field);
	vue3App.use(CellGroup);
	vue3App.use(Form);
};
